import { BaseApiClient } from './base-client';

export interface FTPUser {
  username: string;
  enabled: boolean;
  permissions: string;
}

export interface FTPStatus {
  enabled: boolean;
  service_running: boolean;
  port: number;
  users: FTPUser[];
  bound_to_public?: boolean;
}

export interface FTPToggleRequest {
  enabled: boolean;
}

export interface FTPUserRequest {
  username: string;
  enabled: boolean;
}

export interface FTPPermissionsRequest {
  username: string;
  permissions: string;
}

export class FTPApiClient extends BaseApiClient {

  async getStatus(serviceId: number): Promise<FTPStatus> {
    try {
      return await this.get<FTPStatus>(`/api/v1/ftp/${serviceId}/status`);
    } catch (error: any) {
      throw error.response?.data || error;
    }
  }

  // FTP service is always enabled - removed toggle functionality

  async toggleUser(serviceId: number, username: string, enabled: boolean): Promise<void> {
    try {
      const endpoint = enabled ? 'enable' : 'disable';
      await this.post(`/api/v1/ftp/${serviceId}/users/${username}/${endpoint}`, {});
    } catch (error: any) {
      throw error.response?.data || error;
    }
  }

  async setUserPermissions(serviceId: number, username: string, permissions: string): Promise<void> {
    try {
      await this.put(`/api/v1/ftp/${serviceId}/users/${username}/permissions`, { permissions });
    } catch (error: any) {
      throw error.response?.data || error;
    }
  }

  async updateSettings(serviceId: number, settings: { bind_to_public?: boolean }): Promise<void> {
    try {
      await this.put(`/api/v1/ftp/${serviceId}/settings`, settings);
    } catch (error: any) {
      throw error.response?.data || error;
    }
  }
}